<template>
	<div class="innerBox">
		<h1>Supplier Voucher</h1>

		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<!-- <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label>Status</label>
              <MultiSelect
                v-model="filter.status"
                :options="options.status"
                :custom-label="s => s.charAt(0).toUpperCase() + s.slice(1)"
                placeholder="Pilih Status"
              ></MultiSelect>
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label>Dipesan Oleh</label>
              <MultiSelect
                v-model="filter.po_by"
                :options="options.po_by"
                :custom-label="s => s.charAt(0).toUpperCase() + s.slice(1)"
                placeholder="Pilih Pemesan"
              ></MultiSelect>
            </div> -->
					<!-- <div class="col-md-3 col-12" :class="mobile ? 'pt-20' : ''">
				<label for="partshopCode">Work Order Code</label>
				<flat-pickr
					v-model="selected.date"
					:config="rangeConfig"
					placeholder="Pilih Tanggal"
				></flat-pickr>
			</div> -->
					<div class="col-md-3 col-12" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Cari</label>
						<input type="text" class="form-control" v-model="filter.search"  style="height:43px"/>
					</div>
					<div class="col-md-3 col-12" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>
					</div>
					<div
						class="col-md-3 offset-md-3"
						style="display: flex; flex-direction: column-reverse"
						:class="mobile ? 'pt-20' : ''"
					>
						<button
							type="button"
							class="btn btn-primary"
							style="height:43px; margin-bottom:0.5%"
							@click="generateData()"
						>
							Filter
						</button>
					</div>
				</div>
			</div>
		</panel>

		<div class="row mt-3 mb-3">
			<div class="offset-6 col-6 offset-md-9 col-md-3">
				<button
					class="btn btn-info w-100"
					@click="$router.push({ name: 'SupplierVoucherCreate' })"
				>
					Posting Supplier Voucher Baru
				</button>
			</div>
		</div>
		
		<table class="table text-center">
			<thead>
				<th>No.</th>
				<th>Kode Voucher</th>
				<th>Supplier</th>
				<th>Type</th>
				<th>Tanggal Posting Voucher</th>
				<th>Tanggal Pembayaran</th>
				<th>Nomor WO</th>
				<th>No Pol</th>
				<th>Tipe Mobil</th>

				<th><i class="fa fa-cog"></i></th>
			</thead>
			<template v-if="data">
				<tbody v-for="(dat, index) in Object.keys(data)" :key="index">
					<tr>
						<td :rowspan="data[dat].list.length">{{ index + 1 }}.</td>
						<td :rowspan="data[dat].list.length">
							{{ data[dat].sv_code }}
						</td>
						<td :rowspan="data[dat].list.length">
							{{ data[dat].supplier }}
						</td>
						<td :rowspan="data[dat].list.length">
							{{ data[dat].list[0].type }}
						</td>
						<td :rowspan="data[dat].list.length">
							{{
								new moment(data[dat].created_at).format(
									"MMM DD, YYYY HH:mm"
								)
							}}
						</td>
						<td :rowspan="data[dat].list.length">
							{{
								data[dat].payment_date ?
								new moment(data[dat].payment_date).format(
									"MMM DD, YYYY"
								)
								: '-'
							}}
						</td>
						<td>
							{{
								data[dat].list[0].workorder_code
									? data[dat].list[0].workorder_code
									: "-"
							}}
						</td>
						<td>
							{{
								data[dat].list[0].registration
									? data[dat].list[0].registration
									: "-"
							}}
						</td>
						<td>
							{{
								data[dat].list[0].car_name
									? data[dat].list[0].car_name
									: "-"
							}}
						</td>
						<td :rowspan="data[dat].list.length">
							<button
								class="btn btn-primary"
								name="View Detail"
								@click="viewDetail(data[dat])"
							>
								<i class=" fa fa-eye"></i>
							</button>
						</td>
					</tr>
					<tr v-for="dat2 in data[dat].list.slice(1)">
						<td>
							{{ dat2.workorder_code ? dat2.workorder_code : "-" }}
						</td>
						<td>{{ dat2.registration ? dat2.registration : "-" }}</td>
						<td>{{ dat2.car_name ? dat2.car_name : "-" }}</td>
					</tr>
				</tbody>
			</template>
		</table>
		<div class="text-center mt-3 mb-3">
			<div class="spinner-border" role="status" style="width:5rem;height:5rem" v-if="loading">
				<span class="sr-only" >Loading...</span>
			</div>
		</div>
		<div class="row">
			<div :class="{ 'col-4': !mobile }"></div>
			<div style="padding: 20px" :class="mobile ? 'col' : 'col-4'">
				<nav>
					<ul class="pagination" style="justify-content:center">
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(1)"
						>
							<span class="page-link">&laquo;</span>
						</li>
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(5)"
						>
							<span class="page-link">&lsaquo;</span>
						</li>
						<li class="page-item pageNumber" style="cursor:pointer">
							<span class="page-link" style="color:black">
								<span style="font-weight: bold !important">{{
									config.last_page < 1
										? 0
										: config.current_page
								}}</span>
								of {{ config.last_page }}
							</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(6)"
						>
							<span class="page-link">&rsaquo;</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(10)"
						>
							<span class="page-link">&raquo;</span>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	data() {
		return {
			moment,
			mobile: this.isMobile(),
			modal: {
				view: false,
			},
			rangeConfig: {
				mode: "range",
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL(),
			},
			options: {
				status: ["pending", "arrived", "return"],
				po_by: ["insurance", "workshop"],
			},
			selected: {
				date: "",
			},
			data: null,
			filter: {
				start : null,
				end : null,
				search : ''
			},
			config: {
				current_page : 1,
				last_page : 1
			},
			dummyData: null,
			reloadTable: true,
			loading : false
		};
	},
	mounted() {
		this.generateData(null);
	},
	watch: {
		"selected.date"() {
			var date = this.selected.date.split(" to ");
			this.filter.start = date[0];
			this.filter.end = date[1];
		},
	},
	methods: {
		viewDetail(a) {
			a = JSON.stringify(a);
			this.$router.push({
				name: "SupplierVoucherDetails",
				params: { data: a },
			});
		},
		generateData(numPage) {
			this.loading = true
			let filter = JSON.parse(JSON.stringify(this.filter));
			if (numPage) {
				filter.page = numPage;
			} else if (this.config) {
				filter.page = this.config.current_page;
			}

			let createQs = this.getQs(filter, false);
			this.$http
				.get("/api/v1/treasury/supplier-voucher" + createQs)
				.then((resp) => {
					// this.data = resp.data.data

					let data = resp.data.data;
					let parsedData = {};

					for (var i = 0; i < data.length; i++) {
						let curData = data[i];
						// parsedData[curData.workorder_code] ? parsedData[curData.workorder_code] = [curData] : parsedData[curData]

						if (!parsedData[curData.sv_code]) {
							parsedData[curData.sv_code] = {};
							parsedData[curData.sv_code].sv_code =
								curData.sv_code;
							parsedData[curData.sv_code].supplier = curData.name;
							parsedData[curData.sv_code].created_at =
								curData.created_at;
							//parsedData[curData.sv_code].car_name = curData.car_name
							parsedData[curData.sv_code].payment_date = curData.payment_date
							parsedData[curData.sv_code].references_no = curData.references_no
							parsedData[curData.sv_code].references_img = curData.references_img
							parsedData[curData.sv_code].list = [curData];
							curData.attachment
								? (parsedData[curData.sv_code].attachment =
										curData.attachment)
								: null;
						} else {
							curData.attachment
								? (parsedData[curData.sv_code].attachment =
										curData.attachment)
								: null;
							parsedData[curData.sv_code].list.push(curData);
						}
					}
					this.data = parsedData;
					this.config = resp.data.meta;
					this.loading = false
				})
				.catch((err) => {
					console.log(err);
					this.loading = false
				});
		},
		changePage(opt) {
			//1 First, 5 previous, 6 next, 10 last
			switch (opt) {
				case 1: //laquo - First Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 5: //lsaquo - Previous Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(this.config.current_page - 1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 6: //rsaquo - Next Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.current_page + 1);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				case 10: //raquo - Last Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.last_page);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				default:
					this.newError("Pagination Error, Read Documentation");
			}
		},
		getQs(filter, flag) {
			let stringUrl = "?";
			let keys = Object.keys(filter);

			for (var i = 0; i < keys.length; i++) {
				if (flag == true && keys[i] == "type") continue;

				if (!filter[keys[i]] || filter[keys[i]] == "") continue;
				stringUrl += `${keys[i]}=${filter[keys[i]]}&`;
			}

			return stringUrl;
		},
	},
};
</script>

<style scoped></style>
